export default __webpack_public_path__ + "static/media/spooky_hill_background_l2.b770c6d1.jpg";